import { type Moment } from "moment";
import { useMemo } from "react";

import { DateTimeConverter, DateTimeFormat } from "../lib/date-time-converter";

type DateTimeProps = {
  date: Date | Moment;
  /**
   * LT  1:30 PM
   *
   * LTS 1:30:05 PM
   *
   * L 11/25/2021
   *
   * l    11/25/2021
   *
   * LL    November 25, 2021
   *
   * ll    Nov 25, 2021
   *
   * LLL   November 25, 2021 1:30 PM
   *
   * lll   Nov 25, 2021 1:30 PM
   *
   * LLLL  Thursday, November 25, 2021 1:30 PM
   *
   * llll  Thu, Nov 25, 2021 1:30 PM
   */
  format?: DateTimeFormat;
  customFormat?: string;
  fromNow?: boolean;
  className?: string;
};

export const DateTime: React.FC<DateTimeProps> = ({
  fromNow,
  date: dateRaw,
  format,
  customFormat,
  className,
}) => {
  const date = useMemo(() => {
    if (fromNow === true) return DateTimeConverter.fromNow(dateRaw);

    return DateTimeConverter.format(dateRaw, format ?? customFormat);
  }, [customFormat, dateRaw, format, fromNow]);

  const title = useMemo(() => DateTimeConverter.format(dateRaw), [dateRaw]);

  return (
    <span className={className} title={title}>
      {date}
    </span>
  );
};
